export type PricingState = 'priced' | 'calculating' | 'manual';

export interface PricingStateInput {
    safe_auto_quote?: boolean;
    needs_manual_quote?: boolean;
    is_pricing_in_progress?: boolean;
}

/**
 * What a line item's price area shows. "calculating" covers the gap where the geometry is
 * ready but the analyses that decide the instant price (BREP/Fastlane, SFA) have not ended,
 * so the manual-quote fallback is not final yet.
 */
export const getPricingState = (item?: PricingStateInput | null): PricingState => {
    // While an analysis that decides FastLane or Standard eligibility is running, even a priced
    // item can still change its prices: show "calculating" until the analyses end.
    if (item?.is_pricing_in_progress) return 'calculating';
    return item?.safe_auto_quote && !item?.needs_manual_quote ? 'priced' : 'manual';
};
